import React from 'react';
import { useTranslation } from 'react-i18next';
import { MessagesSquare } from 'lucide-react';
import type { ReviewQuestion } from '../../../types/drbfm';

interface ReviewQuestionListProps {
  questions: ReviewQuestion[];
}

const ReviewQuestionList: React.FC<ReviewQuestionListProps> = ({ questions }) => {
  const { t } = useTranslation();

  return (
    <div>
      <p className="revy-cjk mb-2 text-sm font-medium leading-[1.5]">
        {t('drbfm.decisionMemory.followUpQuestions', 'AI追加確認質問')}
      </p>
      <div className="flex flex-col gap-2">
        {questions.map((question) => (
          <div key={question.id} className="rounded-md border p-2.5">
            <div className="flex items-start gap-2">
              <MessagesSquare
                className="mt-0.5 size-4 shrink-0 text-secondary-foreground"
                strokeWidth={1.9}
              />
              <div>
                <p className="revy-cjk text-sm font-semibold leading-[1.6]">{question.question}</p>
                {question.reason && (
                  <p className="revy-cjk text-xs leading-[1.6] text-muted-foreground">
                    {question.reason}
                  </p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewQuestionList;
